var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-tool-bar',{on:{"toggleDrawer":function($event){_vm.drawer = !_vm.drawer}}}),_c('v-content',{staticClass:"page-content"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }